/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, keepPreviousData, useQuery } from '@tanstack/react-query';

import { type Timesheet, type TimesheetRange, timesheetApi } from '../api/timesheet.js';

export function useMyTimesheet(range: TimesheetRange): UseQueryResult<Timesheet> {
  return useQuery({
    queryKey: ['timesheet', 'mine', range],
    queryFn: () => timesheetApi.mine(range),
    placeholderData: keepPreviousData,
  });
}

export function useTherapistTimesheet(
  therapistId: string,
  range: TimesheetRange,
): UseQueryResult<Timesheet> {
  return useQuery({
    queryKey: ['timesheet', 'therapist', therapistId, range],
    queryFn: () => timesheetApi.forTherapist(therapistId, range),
    placeholderData: keepPreviousData,
    enabled: therapistId !== '',
  });
}
